var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddressCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1 3v13h18V3zm1.38 1.3h15.24v10.4H2.38zm4.85 1.3c-1.52 0-2.77 1.17-2.77 2.6 0 .72.33 1.38.85 1.85a3.2 3.2 0 0 0-1.54 2.7h1.38c0-1.08.93-1.95 2.08-1.95s2.08.87 2.08 1.95h1.38c0-1.11-.61-2.12-1.53-2.7.51-.47.84-1.13.84-1.85 0-1.43-1.25-2.6-2.77-2.6m0 1.3c.77 0 1.39.57 1.39 1.3S8 9.5 7.23 9.5s-1.38-.57-1.38-1.3.6-1.3 1.38-1.3m4.85.65v1.3h4.15v-1.3zm0 2.6v1.3h4.15v-1.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddressCard);
export default ForwardRef;